import Vue from 'vue'
import Router from 'vue-router'
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store"
import { CookieGet } from '@/utils/cookie';
import staticRoutes from './staticRoutes';
import { VUE_APP_TITLE } from "@/config";
Vue.use(Router)

// 读取modules中的文件
let context = require.context("./modules", true, /\.js$/)
let childernRoutes = context.keys().reduce((total,fileName)=>{
    total.push(...context(fileName).default)
    return total
},[])

let routes = []

routes.push(...staticRoutes)

routes.push({
    path: '/',
    component: ()=> import("@/views/Layout"),
    children:childernRoutes
},{
    path: '*',
    component: ()=> import("@/views/error-page/404")
},{
	path: '/agreement',
    component: ()=> import("@/views/agreement"),
})

const router = new Router({
	routes
})

// 路由跳转前执行
router.beforeEach(async (to,from,next)=>{
	if(to.meta.title && typeof(to.meta.title) !== "undefined"){
		document.title = to.meta.title
	}else{
		document.title = VUE_APP_TITLE
	}
	Nprogress.start()

	let userId = CookieGet("user_id")
	if(userId){
		store.dispatch("user/getInfo")
		next()
	}else{
		next()
	}
})

// 路由跳转后执行
router.afterEach((to,from)=>{
	Nprogress.done()
})

export default  router